import { render, staticRenderFns } from "./HomeItemTitle.vue?vue&type=template&id=cdd8a362&scoped=true&"
import script from "./HomeItemTitle.vue?vue&type=script&lang=js&"
export * from "./HomeItemTitle.vue?vue&type=script&lang=js&"
import style0 from "./HomeItemTitle.vue?vue&type=style&index=0&id=cdd8a362&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd8a362",
  null
  
)

export default component.exports